// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__AbK3a","left":"Virtual_left__eMFi6","wrapper":"Virtual_wrapper__gSexp"};